import { render, staticRenderFns } from "./MetadataDialog.vue?vue&type=template&id=87dac418&scoped=true"
import script from "./MetadataDialog.vue?vue&type=script&lang=js"
export * from "./MetadataDialog.vue?vue&type=script&lang=js"
import style0 from "./MetadataDialog.vue?vue&type=style&index=0&id=87dac418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dac418",
  null
  
)

export default component.exports